import * as RX from 'rxjs';
import { map, filter } from 'rxjs/operators';
import decodeWith, { decodeThrowing, decodeOption } from '../shared/firebase/decodeHelper';
import * as F from 'fp-ts/lib/function';
import * as Arr from 'fp-ts/Array';
const filterDecodable = (codec, items) => F.pipe(items, Arr.filterMap(item => decodeOption(codec, item)));
export function decodeWithOrError(codec) {
    return RX.pipe(map((item) => decodeThrowing(codec, item)));
}
export function decodable(codec) {
    return RX.pipe(map((item) => {
        return decodeWith(codec, item, true);
    }), filter((item) => !!item));
}
export function decodableInArray(codec) {
    return RX.pipe(map((items) => filterDecodable(codec, items)));
}
